import { MetadataBackupError, parseBackup, serializeBackup, type MetadataBackup } from './metadata-backup.ts';

export const LIBRARY_CLOUD_MAX_BYTES = 1024 * 1024;
export const LIBRARY_CLOUD_MAX_REQUEST_BYTES = LIBRARY_CLOUD_MAX_BYTES + 4096;

/** Stable, credential-free library relationships. Playback/device state stays local. */
export function serializeLibraryCloudSnapshot(input: unknown): string {
  const value = typeof input === 'string' ? parseBackup(input) : parseBackup(serializeBackup(input));
  value.tracks.forEach((track, index) => {
    // Local paths are opaque; absolute URLs and WebDAV hrefs must be stable.
    if (track.sourceType === 'local' && /^[a-z]:[\\/]/i.test(track.externalId)) return;
    let reference: URL;
    try { reference = track.sourceType === 'webdav' ? new URL(track.externalId, 'https://library.invalid/') : new URL(track.externalId); }
    catch { return; }
    if (!/^https?:$/.test(reference.protocol) || reference.username || reference.password || reference.search || reference.hash) {
      throw new MetadataBackupError('INVALID_REFERENCE', '云端索引的来源引用不能包含凭据、临时查询参数或片段', `tracks[${index}].externalId`);
    }
  });
  delete value.exportedAt;
  return serializeBackup({ ...value, queue: [], currentId: null, positions: {}, theme: 'system', playMode: 'sequence', lyricOffsetMs: 0, motionLevel: 'medium', volume: 0.8 });
}

export function parseLibraryCloudSnapshot(input: unknown): MetadataBackup {
  return parseBackup(serializeLibraryCloudSnapshot(input));
}
